import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'studio.N2IrpM',
    defaultMessage: 'Confirm',
  },
  deleteAppFromCollectionBody: {
    id: 'studio.vr3jcJ',
    defaultMessage:
      'Are you sure you want to delete this app from this collection? This will not delete the app itself.',
  },
  deleteAppFromCollection: {
    id: 'studio.vaNOFj',
    defaultMessage: 'Delete app from collection',
  },
  edit: {
    id: 'studio.wEQDC6',
    defaultMessage: 'Edit',
  },
  pinApp: {
    id: 'studio.FayXzX',
    defaultMessage: 'Pin app to top of collection',
  },
  stopEditing: {
    id: 'studio.M1v/6S',
    defaultMessage: 'Stop editing',
  },
  unpinApp: {
    id: 'studio.2VvdnV',
    defaultMessage: 'Unpin app from top of collection',
  },
});
